import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { FaQrcode, FaMobileAlt, FaShieldAlt, FaArrowRight } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Services.css';

const ServicesSection = () => {
  const servicesRef = useRef(null);

  const services = [
    {
      icon: <FaQrcode />,
      title: "UPI Payments",
      description: "Instant UPI transfers & QR code payments with multiple bank support.",
      features: ["Instant Transfers", "QR Code Payments", "Multiple Bank Linking", "Transaction History"]
    },
    {
      icon: <FaMobileAlt />,
      title: "Bill Payments",
      description: "Mobile, electricity, DTH & 100+ bill payments with auto-pay options.",
      features: ["Mobile Recharge", "Utility Bills", "Insurance Premiums", "Credit Card Bills"]
    },
    {
      icon: <FaShieldAlt />,
      title: "Insurance",
      description: "Health, motor & travel insurance from top providers at best prices.",
      features: ["Health Insurance", "Motor Insurance", "Travel Insurance", "Term Life"]
    }
  ];

  const comparisonRows = [
    { feature: 'Social Credit Score', rupayya: '✓', bank: '✗', other: '✗' },
    { feature: 'Community Pods',      rupayya: '✓', bank: '✗', other: '✗' },
    { feature: 'F2F Lending',         rupayya: '✓', bank: '✗', other: 'Limited' },
    { feature: 'Group Funds',         rupayya: '✓', bank: '✗', other: '✗' },
    { feature: 'P2P Lending',         rupayya: '✓', bank: '✗', other: '✓' },
    { feature: 'Zero Hidden Fees',    rupayya: '✓', bank: '✗', other: '✗' }
  ];

  return (
    <section className="services-section" id="services" ref={servicesRef}>
      <div className="container">

        {/* Section header */}
        <div className="section-header">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Complete Financial Ecosystem
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            All your financial needs in one secure app
          </motion.p>
        </div>

        {/* Service cards slider */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000 }}
          breakpoints={{
            320:  { slidesPerView: 1 },
            768:  { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          className="services-slider"
        >
          {services.map((service, idx) => (
            <SwiperSlide key={idx}>
              <motion.div
                className="service-card"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: idx * 0.08 }}
                whileHover={{ y: -8 }}
              >
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, fIdx) => (
                    <li key={fIdx}>{feature}</li>
                  ))}
                </ul>
                <button className="service-cta">
                  Explore <FaArrowRight />
                </button>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Comparison table */}
        <motion.div
          className="services-comparison"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3>Why Rupayya Stands Out</h3>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Rupayya</th>
                  <th>Traditional Banks</th>
                  <th>Other Apps</th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.feature}</td>
                    <td className="check-cell">{row.rupayya}</td>
                    <td className="cross-cell">{row.bank}</td>
                    <td className={row.other === '✓' ? 'check-cell' : 'cross-cell'}>
                      {row.other}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default ServicesSection;
